import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  filterStr: {
    fontWeight: 700
  }
}));
